import React, { Component }  from 'react';
import { Image, Header, Button } from 'semantic-ui-react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';

class ExploreContent extends Component {
  constructor() {
    super();
    this.state = {
      count: 0
    };
  }

  componentDidMount() {
    // update data
    const { name } = this.props;

    let url;

    if (name === 'chamber-music') {
      url = `/go/api/v1/search?q=*&model=songs&start=0&size=0&vocal_chamber_music=true`;
    } else {
      url = `/go/api/v1/${name}/count`;
    }

    fetch(url)
      .then(res => {
        return res.json();
      })
      .then(data => {
        const count = name === 'chamber-music'
          ? data.hits.total
          : data;

        if (!isNaN(count)) {
          this.setState({ count: count });
        }
      })
      .catch(console.error);
  }

  render() {
    const { name, title} = this.props;
    const { count } = this.state;
    const img = `/img/explore-${name}.png`;
    const url = `/${name}`;

    return (
      <React.Fragment>
        <Image src={img} fluid />
        <Header as='h2'>{title}</Header>
        {this.props.children}
        <small className='muted'>
          <NumberFormat
            value={count}
            displayType='text'
            thousandSeparator={true}
          /> records
        </small>
          <Button
            as={Link}
            to={url}
            basic
            icon='arrow right'
            fluid
          />
      </React.Fragment>
    );
  }
}

export default ExploreContent;
